import React from 'react'
import checkmark from '../../assets/svg/icons/checkmark.svg'
import deling from '../../assets/svg/icons/deling.svg'
import dokumenter from '../../assets/svg/icons/dokumenter.svg'
import karnov from '../../assets/svg/icons/karnov.svg'
import kryss from '../../assets/svg/icons/kryss.svg'
import merknader from '../../assets/svg/icons/ikon-innearbeid.svg'
import notater from '../../assets/svg/icons/notater.svg'
import search from '../../assets/svg/icons/search.svg'
import utvalg from '../../assets/svg/icons/utvalg.svg'
import varslinger from '../../assets/svg/icons/varslinger.svg'
import feide from '../../assets/svg/icons/feide.svg'
import mobile from '../../assets/svg/icons/mobile.svg'

export default function Icon({icon}) {

	const chooseIcon = () => {
		switch(icon) {
			case 'Varslinger': {
				return <img src={varslinger} alt={icon} />
			}
			case 'Notater': {
				return <img src={notater} alt={icon} />
			}
			case 'Søk': {
				return <img src={search} alt={icon} />
			}
			case 'Utvalg': {
				return <img src={utvalg} alt={icon} />
			}
			case 'Dele': {
				return <img src={deling} alt={icon} />
			}
			case 'Dokumenter': {
				return <img src={dokumenter} alt={icon} />
			}
			case 'Merknader': {
				return <img src={merknader} alt={icon} />
			}
			case 'Alt': {
				return <img src={checkmark} alt={icon} />
			}
			case 'Krysshenvisninger': {
				return <img src={kryss} alt={icon} />
			}
			case 'Lovkommentarer': {
				return <img src={karnov} alt={icon} />
			}
			case 'Feide': {
				return <img src={feide} alt={icon} />
			}
			case 'Mobil': {
				return <img src={mobile} alt={icon} />
			}
			default: {
				return null
			}
		}
	}

	return(
		<div className="Icon">
			{chooseIcon()}
		</div>
	)
}